<template>
	<div id="hrms75e-detail-tab4" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#tab4">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRMS75EC5']['10'] }}
      </h3>
    </div>
    <div id="tab4" class="panel-collapse collapse tab-detail">
      <div class="panel-body">
        <div class="detail detail-responsive panel-detail-filter">
          <div class="col-md-8">
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-6 control-label">{{ labels['HRMS75EC5']['20'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ detail.detail.desc_codempid }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-6 control-label">{{ labels['HRMS75EC5']['30'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ detail.detail.desc_codcomp }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-6 control-label">{{ labels['HRMS75EC5']['40'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ detail.detail.desc_codpos }}</div>
                </div>
              </div>
            </form>
          </div>
          <hrms-table   :columns="detailTab4Columns" 
                        :data="detail.table"
                        :searchDisp="false" /> 		
        </div>
        <div class="col-md-12 ">
          <button type="button" class="btn bg-color-skin pull-right" data-toggle="modal" data-target="#hrms75e-popup-tab4" @click="togglePopupDetailTab4()">{{ labels['HRMS75EC5']['90'] }}</button>   
        </div>
      </div>
    </div>
    <popup  :labels="labels"
            :nowLang="nowLang"
            :labelsButton="labelsButton"
            :detailTab4Popup="detailTab4Popup"
            :detailTab4PopupColumns="detailTab4PopupColumns" 
            :setAddCodcours="setAddCodcours"/>
  </div>

</template>
<script>
import popup from 'components/hrms75e/popupTab4'

export default {
  name: 'hrms75e-detail-tab4',
  props: [
    'labels',
    'data',
    'labelsButton',
    'nowLang',
    'detail',
    'codempid',
    'detailTab4Columns',
    'detailTab4Popup',
    'detailTab4PopupColumns',
    'receivedHrms75eDetailTab4Popup',
    'setAddCodcours'
  ],
  methods: {
    togglePopupDetailTab4 () {
      let popupParams = {
        codempid: this.codempid
      }
      this.receivedHrms75eDetailTab4Popup(popupParams)
    }
  },
  components: {
    popup
  }
}
</script>


// WEBPACK FOOTER //
// detailTab4.vue?3d7d43f0